@if (!showDefaultImage && !showShortName) {
  <img lib-amdocs-image-version (error)="showDefaultImage = true" class="avatar {{fontClass}}" [src]="fullPath" />
}
@if (showDefaultImage || showShortName) {
  <span class="avatar {{fontClass}}" >{{userShortName}}</span>
}

